var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        _vm._b(
          {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover.viewport.noninteractive",
                value: "Delete",
                expression: "'Delete'",
                modifiers: {
                  hover: true,
                  viewport: true,
                  noninteractive: true,
                },
              },
            ],
            class: _vm.buttonClass,
            attrs: {
              variant: "variant" in _vm.$attrs ? _vm.$attrs.variant : "danger",
              size: "size" in _vm.$attrs ? _vm.$attrs.size : "sm",
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                _vm.confirmationModal = true
              },
            },
          },
          "b-button",
          _vm.$attrs,
          false
        ),
        [
          _vm._t("default", function () {
            return [_c("b-icon", { attrs: { icon: "trash" } })]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Please Confirm",
            "ok-title": "Yes",
            "cancel-title": "No",
            "auto-focus-button": "ok",
            centered: "",
          },
          on: {
            ok: function ($event) {
              return _vm.$emit("confirm")
            },
          },
          model: {
            value: _vm.confirmationModal,
            callback: function ($$v) {
              _vm.confirmationModal = $$v
            },
            expression: "confirmationModal",
          },
        },
        [_c("div", { domProps: { innerHTML: _vm._s(_vm.confirmationHtml) } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }